export default __webpack_public_path__ + "media/arrow-ios-up.120fb029.svg";